import LeaveQuota from './LeaveQuota'
import LeaveRequest from './LeaveRequest'
import LeaveData from './LeaveData'
import LeaveBranch from './LeaveBranch'
import LeaveEmployeeApprove from './LeaveEmployeeApprove'
import ReportLeave from './ReportLeave'
import ReportLeaveBranch from './ReportLeaveBranch'
import ReportLeaveDepartment from './ReportLeaveDepartment'
import LeaveQuotaEmp from './LeaveQuotaEmp'

export default {
  LeaveQuota,
  LeaveRequest,
  LeaveData,
  LeaveEmployeeApprove,
  LeaveBranch,
  ReportLeave,
  ReportLeaveBranch,
  ReportLeaveDepartment,
  LeaveQuotaEmp
}



// WEBPACK FOOTER //
// ./src/components/HRM/Leave/index.js